// Hook die een nieuwe Decca-conversatie aanmaakt + Decca opent. Bundle van de
// pre-existing pattern uit `AIEffectAnalysis.jsx` (analysisHandler).
//
// Gebruik:
//
//   const startConversation = useStartDeccaConversation()
//
//   await startConversation({
//       subject: 'TOCOnboarding',
//       title: 'Theory of Change inrichten',
//       welcomeMessage: '<h2>Hallo!</h2><p>Laten we je TOC verder afmaken.</p>',
//       contextData: { ... },                  // optioneel
//       mode: 'fullscreen' | 'sidebar',        // default 'sidebar'
//   })
//
// Geen live Firestore-listener — Position-count gaat via een one-shot get
// pas zodra de gebruiker daadwerkelijk klikt. Dat scheelt een permanente
// Conversations-subscription op iedere geauthenticeerde pagina.

import { useContext } from 'react'
import uuid from 'react-uuid'

import { Auth } from '../StateManagment/Auth'
import { DeccaContext } from '../StateManagment/DeccaContext'
import { client } from './Client'
import { db, timestamp } from '../firebase/config'
import newConversation from '../agents/newConversation'

const useStartDeccaConversation = () => {

    const [auth] = useContext(Auth)
    const {
        setSubject,
        setContextData,
        setSelectedConversationID,
        setShowConversations,
        setDeccaState,
        setChatOpen,
    } = useContext(DeccaContext)

    const start = async ({
        subject,
        title,
        welcomeMessage,
        contextData = null,
        mode = 'sidebar',
    }) => {

        const conversationID = uuid()

        // Decca-state setters — vóór de Firestore-write zodat de UI direct
        // reageert ook al duurt de write nog even.
        setSubject(subject)
        if (contextData) setContextData(contextData)

        if (mode === 'fullscreen') {
            setDeccaState('fullscreen')
        } else {
            setChatOpen(true)
        }

        // One-shot Position-count (geen live listener)
        let nextPosition = 1
        try {
            const snap = await db.collection('Conversations')
                .where('CompagnyID', '==', client)
                .get()
            nextPosition = snap.size + 1
        } catch (err) {
            console.error('useStartDeccaConversation: kon conversation-count niet ophalen', err)
            // Niet-blokkerend — maak conversation aan met fallback Position 1
        }

        await newConversation(
            conversationID,
            title,
            welcomeMessage,
            nextPosition,
            client,
            timestamp,
            uuid(),
            auth?.ID,
            auth?.ForName,
            db,
        )

        setSelectedConversationID(conversationID)
        setShowConversations(false)

        return conversationID
    }

    return start

}

export default useStartDeccaConversation
